export function normalizeDomains(domains: unknown): string[] {
  if (Array.isArray(domains)) {
    return domains.flatMap((domain) => normalizeDomains(domain));
  }

  if (typeof domains === 'string' && domains.trim()) {
    const trimmed = domains.trim();

    if (trimmed.startsWith('[')) {
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) {
          return normalizeDomains(parsed);
        }
      } catch {
        // Fall through to comma-separated parsing.
      }
    }

    return trimmed
      .split(',')
      .map((domain) => domain.replace(/^["']|["']$/g, '').trim())
      .filter(Boolean);
  }

  return [];
}
